import { useForm } from "react-hook-form";
import { CHANGE_CONTACT_NUMBER_VALIDATE_OTP, postChangeContactNumberSendOtpRoute } from "@api-routes";
import { useFetch } from "@common/hook/useFetch";
import { getLanguage } from "@utils/changeLanguage";
import { PhoneNumberUtil } from "google-libphonenumber";

const phoneUtil = PhoneNumberUtil.getInstance();

export interface IValidateOtpResponse {
    success: boolean;
    validOtp: boolean;
}

export const useChangeContactNumber = (
    setIsMobileNumberValid: (valid: boolean) => void,
    setIsOtpCodeValid: (valid: IValidateOtpResponse) => void,
    setShowOtp: (valid: boolean) => void,
    callback: () => void
) => {
    const [sendOtpState, { post: postSendOtp }] = useFetch();
    const [validateOtpState, { post: postValidateOtp }] = useFetch();
    const formMethods = useForm<{ mobileNumber: string }>({
        defaultValues: { mobileNumber: "" },
    });
    const lang = getLanguage();

    const handleSendOtp = (mobileNumber: String) => {
        postSendOtp<boolean>(postChangeContactNumberSendOtpRoute(lang), {
            body: {
                msisdn: mobileNumber,
            },
        }).then((response) => {
            setIsMobileNumberValid(response || false);
            setShowOtp(response || false);
        });
    };

    const handleValidateOtp = (mobileNumber: string, otpCode: string) => {
        const fullNumber = "+".concat(mobileNumber);
        const parsedNumber = phoneUtil.parseAndKeepRawInput(fullNumber);
        
        const countryCode = parsedNumber.getCountryCode();
        const msisdn = parsedNumber.getNationalNumber();

        postValidateOtp<IValidateOtpResponse>(CHANGE_CONTACT_NUMBER_VALIDATE_OTP, {
            body: {
                otpCode: otpCode,
                countryCode: countryCode,
                msisdn: msisdn,
            },
        }).then((response) => {
            setIsOtpCodeValid(response || { success: false, validOtp: false });
            if (response?.success && response?.validOtp) callback();
        });
    };

    return { formMethods, handleSendOtp, sendOtpState, handleValidateOtp, validateOtpState };
};
